import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { RowSumCancelledType } from '../../../types/ancillaryCostTableRowTypes';
import { useBookingContext } from '../../../hooks/use-booking-context';

interface props {
  row: RowSumCancelledType;
  index: string;
  surchargeValues: { [key: string]: string };
  rebooking: boolean | undefined;
  totalCost: number;
  commonStyles: any;
  uniqueRows: any;
  showAdjustedSurcharge: boolean | undefined;
}

const SummaryRow: React.FC<props> = ({
  row,
  index,
  surchargeValues,
  rebooking,
  totalCost,
  commonStyles,
  uniqueRows,
  showAdjustedSurcharge,
}) => {
  const { costFormatter } = useBookingContext();

  const sumByKey = (data: any[], keys: string[]): { [key: string]: number } => {
    return data.reduce((acc, curr) => {
      keys.forEach(key => {
        if (typeof curr[key] === 'number') {
          if (!acc[key]) acc[key] = 0;
          acc[key] += curr[key];
        }
      });
      return acc;
    }, {});
  };

  const keys = ['surcharge', 'originalPrice', 'newPrice'];
  const totals = sumByKey(uniqueRows, keys);

  const serviceFee = Number(surchargeValues['Service Fee']?.replace(',', '.') ?? 0);

  return (
    <TableRow key={index}>
      <TableCell align="left" sx={{ borderTop: '2px solid #737373', borderBottom: 'none' }}></TableCell>
      <TableCell sx={{ ...commonStyles.cellHeader, backgroundColor: '#F3F0EC', borderTop: '2px solid #737373' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography sx={commonStyles.typography}>{row.sumCancelled}</Typography>
          <Typography sx={commonStyles.typography}>{costFormatter.format(totals?.originalPrice ?? 0)}</Typography>
        </Box>
      </TableCell>
      <TableCell sx={{ ...commonStyles.cellHeader, backgroundColor: '#E2F5FD', borderTop: '2px solid #737373' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography sx={commonStyles.typography}>{row.sumNew}</Typography>
          <Typography sx={commonStyles.typography}>{costFormatter.format(totals?.newPrice + serviceFee)}</Typography>
        </Box>
      </TableCell>
      <TableCell sx={{ width: '240px', backgroundColor: '#AAE0F9', borderTop: '2px solid #737373' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography sx={commonStyles.typography}>{row.total}</Typography>
          {!showAdjustedSurcharge && (
            <Typography
              sx={totalCost < 0 ? commonStyles.errorTypography : commonStyles.typography}
              style={{ textAlign: 'right' }}
            >
              {costFormatter.format((totals?.newPrice ?? 0) - (totals?.originalPrice ?? 0) + serviceFee)}
            </Typography>
          )}
        </Box>
      </TableCell>
      {showAdjustedSurcharge && (
        <TableCell sx={{ backgroundColor: '#AAE0F9', borderTop: '2px solid #737373' }}>
          <Typography
            sx={totalCost < 0 ? commonStyles.errorTypography : commonStyles.typography}
            style={{ textAlign: 'right' }}
          >
            {costFormatter.format(totalCost)}
          </Typography>
        </TableCell>
      )}
    </TableRow>
  );
};
export default SummaryRow;
